<template>
  <form @submit.prevent>
    <h6 class="heading-small text-muted mb-4">ข้อมูล</h6>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <!-- คำนำหน้า  -->
            <span class="text-danger">*</span>{{isShow.nameTitle}}
          </label>
          <v-select 
            :class="[ { 'is-invalid bd-danger': submitForm && $v.data.name_title.$error } , 'w-100' ]"
            :label="isShow.listNameTitle"
            :options="ListNameTitle"
            @input="switchTabForCommission()"
            placeholder="กรุณาเลือกคำนำหน้า"
            v-model="data.name_title"
          ></v-select>
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.data.name_title.required"
            class="invalid-feedback d-block"
          >กรุณาเลือกคำนำหน้า</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.name}}
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.name.$error }"
            :placeholder="isShow.name"
            v-model="data.name"
            @change="manageNameAccout()"
          />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.data.name.minLength"
          >กรุณากรอก"ชื่อ-นามสกุล"อย่างน้อย {{$v.data.name.$params.minLength.min}} ตัวอักษร</label>
          <label
            v-if="submitForm && !$v.data.name.required"
            class="invalid-feedback"
          >กรุณากรอกชื่อ-นามสกุล</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.card_id}}
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.tax_id.$error }"
            :placeholder="isShow.card_id"
            v-model="data.tax_id"
            @change="checkTax"
          />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.data.tax_id.minLength"
          >กรุณากรอก"{{isShow.card_id}}"อย่างน้อย {{$v.data.tax_id.$params.minLength.min}} ตัวเลข</label>
          <label
            class="error invalid-feedback"
            v-if="!$v.data.tax_id.maxLength"
          >กรุณากรอก"{{isShow.card_id}}"ไม่เกิน {{$v.data.tax_id.$params.maxLength.max}} ตัวเลข</label>
          <label
            v-if="submitForm && !$v.data.tax_id.required"
            class="invalid-feedback"
          >กรุณากรอก{{isShow.card_id}}</label>
          <small
            v-if="data.errorTax"
            class="text-danger"
          >กรุณากรอกหมายเลขบัตรประชนชนให้ถูกต้อง</small>
        </div>
      </div>
      <div class="col-lg-6" v-if="isShow.visible.laser_code">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.laser_code}}
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.laser_code.$error }"
            :placeholder="isShow.laser_code"
            v-model="data.laser_code"
          />
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.data.laser_code.required"
            class="invalid-feedback"
          >กรุณากรอกเลขหลังบัตรประชาชน</label>
        </div>
      </div>
      <div class="col-lg-6" v-if="isShow.visible.date_birthday">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.date_birthday}}
          </label>
          <input
            type="date"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.date_birthday.$error }"
            :placeholder="isShow.date_birthday"
            v-model="data.date_birthday"
          />
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.data.date_birthday.required"
            class="invalid-feedback"
          >กรุณาเลือกวันเกิด</label>
        </div>
      </div>
      <div class="col-lg-6" v-if="isShow.visible.date_expiry">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.date_expiry}}
          </label>
          <input
            type="date"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.date_expiry.$error }"
            :placeholder="isShow.date_expiry"
            v-model="data.date_expiry"
          />
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.data.date_expiry.required"
            class="invalid-feedback"
          >กรุณาเลือกวันที่บัตรหมดอายุ</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.tel}}
          </label>
          <input
            type="number"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.tel.$error }"
            :placeholder="isShow.tel"
            v-model="data.tel"
          />
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.data.tel.required"
            class="invalid-feedback"
          >กรุณากรอกเบอร์โทรศัพท์</label>
          <label
            class="error invalid-feedback"
            v-if="!$v.data.tel.minLength"
          >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย {{$v.data.tel.$params.minLength.min}}ตัวเลข</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.email}} <small class="text-muted">(ใช้สำหรับ แจ้งสลิปการโอนเงิน)</small>
          </label>
          <div :class="['form-group', { 'input-group': typeFormTab == 'cod' ? true : false }]">
            <input 
              :disabled="disabledEmail"
              type="text" 
              class="form-control" 
              :class="{ 'is-invalid': submitForm && $v.data.email.$error }"
              :placeholder="isShow.email"
              v-model="data.email"
            />
            <div class="loading-box">
              <div class="loader-autocomplete" v-show="loadingEmail"></div>
            </div>
            <div class="input-group-append" v-if="typeFormTab == 'cod'">
              <button 
                :disabled="disabledEmail"
                class="btn px-3 btn-sm btn-info"
                @click="genEmailShippop()"
              >Gen Email</button>
            </div>
            <div class="warning-duplicate-email text-muted">ไม่สามารถแก้ไขข้อมูลได้ในภายหลัง โปรดใช้ข้อมูลจริงเท่านั้น</div>
            <!-- vuelidate -->
            <div>
              <label
                v-if="submitForm && !$v.data.email.required"
                class="invalid-feedback"
              >กรุณากรอกอีเมล์</label>
              <label
                v-if="submitForm && !$v.data.email.email"
                class="invalid-feedback"
              >รูปแบบอีเมล์ไม่ถูกต้อง</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>
            <span class="text-danger">*</span> {{isShow.address}}
          </label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.data.address.$error }"
            :placeholder="isShow.address"
            v-model="data.address"
          />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.data.address.minLength"
          >กรุณากรอก"ที่อยู่"อย่างน้อย {{$v.data.address.$params.minLength.min}} ตัวอักษร</label>
          <label
            v-if="submitForm && !$v.data.address.required"
            class="invalid-feedback"
          >กรุณากรอกที่อยู่</label>
        </div>
      </div>
      <!-- ตำบล -->
      <div class="col-lg-6">
        <div class="form-group">
          <label floater>
            <small class="text-danger">*</small> ตำบล/แขวง
          </label>
            <AutocompletesAddress
              :queryInput="data.state" 
              :adsTypes="'sub-district'"
              placeHolder="ตำบล/แขวง"
              :class="{ 'is-invalid': submitForm && $v.data.state.$error }"
              @input="data.state = $event.target.value"
              @select:item="onSubmitAddress( $event , 'data' )">
            </AutocompletesAddress>
          <!-- vuelidate -->
          <div
            v-if="submitForm && !$v.data.state.required"
            class="invalid-th-address"
          >กรุณากรอกตำบล/แขวง</div>
        </div>
      </div>
      <!-- อำเภอ -->
      <div class="col-lg-6">
        <div class="form-group">
          <label floater>
            <small class="text-danger">*</small> อำเภอ/เขต
          </label>
            <AutocompletesAddress
              :queryInput="data.district" 
              :adsTypes="'district'"
              placeHolder="อำเภอ/เขต"
              :class="{ 'is-invalid': submitForm && $v.data.district.$error }"
              @input="data.district = $event.target.value"
              @select:item="onSubmitAddress( $event , 'data' )">
            </AutocompletesAddress>
          <!-- vuelidate -->
          <div
            v-if="submitForm && !$v.data.district.required"
            class="invalid-th-address"
          >กรุณากรอกอำเภอ/เขต</div>
        </div>
      </div>
      <!-- จังหวัด -->
      <div class="col-lg-6">
        <div class="form-group">
          <label floater>
            <small class="text-danger">*</small> จังหวัด
          </label>
            <AutocompletesAddress
              :queryInput="data.province" 
              :adsTypes="'province'"
              placeHolder="จังหวัด"
              :class="{ 'is-invalid': submitForm && $v.data.province.$error }"
              @input="data.province = $event.target.value"
              @select:item="onSubmitAddress( $event , 'data' )">
            </AutocompletesAddress>
          <!-- vuelidate -->
          <div
            v-if="submitForm && !$v.data.province.required"
            class="invalid-th-address"
          >กรุณากรอกจังหวัด</div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label floater>
            <small class="text-danger">*</small> รหัสไปรษณีย์
          </label>
            <AutocompletesAddress
              :queryInput="data.postcode" 
              :adsTypes="'postcode'"
              placeHolder="รหัสไปรษณีย์"
              :class="{ 'is-invalid': submitForm && $v.data.postcode.$error }"
              @input="data.postcode = $event.target.value"
              @select:item="onSubmitAddress( $event , 'data' )">
            </AutocompletesAddress>
          <!-- vuelidate -->
          <div
            v-if="submitForm && !$v.data.postcode.required"
            class="invalid-th-address"
          >กรุณากรอกรหัสไปรษณีย์</div>

          <div
            class="error invalid-th-address"
            v-if="submitForm && !$v.data.postcode.minLength"
          >กรุณากรอก"รหัสไปรษณีย์" {{$v.data.postcode.$params.minLength.min}} หลัก</div>

          <div
            class="error invalid-th-address"
            v-if="submitForm && !$v.data.postcode.maxLength"
          >กรุณากรอก"รหัสไปรษณีย์" {{$v.data.postcode.$params.maxLength.max}} หลัก</div>

          <div
            class="error invalid-th-address"
            v-if="submitForm && !$v.data.postcode.numeric"
          >กรุณากรอกเฉพาะตัวเลข</div>
        </div>
      </div>
    </div>
    <h6 class="heading-small text-muted mb-4">ข้อมูลบัญชีธนาคาร</h6>
    <div class="row" v-for="(acc, index) in account" :key="index">
      <div class="col-lg-12">
        <div class="form-group">
          <label><span class="text-danger">*</span>{{ (account.length > 1 ? ` ${isShow.account_bank} ${index+1}` : ` ${isShow.account_bank}`)}}</label>
          <v-select 
            :class="[ { 'is-invalid bd-danger': submitForm && $v.account.$each[index].account_bank.$error } , 'w-100' ]"
            label="name"
            placeholder="กรุณาเลือกธนาคาร"
            :key="acc.account_bank"
            :options="bank"
            v-model="acc.account_bank"
            :reduce="formatBank => formatBank.code"
          ></v-select>
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.account.$each[index].account_bank.required"
            class="invalid-feedback d-block"
          >กรุณาเลือกธนาคาร</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label><span class="text-danger">*</span>{{ (account.length > 1 ? ` ${isShow.account_name} ${index+1}` : ` ${isShow.account_name}`)}}</label> <small class="text-muted"> (ต้องตรงกับหน้าชื่อสมุดบัญชี)</small>
          <input
            type="text"
            class="form-control"
            readonly
            :class="{ 'is-invalid': submitForm && $v.account.$each[index].account_name.$error }"
            :placeholder="isShow.account_name"
            v-model="acc.account_name"
          />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.account.$each[index].account_name.minLength"
          >กรุณากรอก"ชื่อบัญชีธนาคาร"อย่างน้อย {{$v.account.$each[index].account_name.$params.minLength.min}} ตัวอักษร</label>
          <label
            v-if="submitForm && !$v.account.$each[index].account_name.required"
            class="invalid-feedback"
          >กรุณากรอกชื่อบัญชีธนาคาร</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label><span class="text-danger">*</span>{{ (account.length > 1 ? ` ${isShow.account_id} ${index+1}` : ` ${isShow.account_id}`)}}</label>
          <input
            type="number"
            class="form-control hide-arrow"
            :class="{ 'is-invalid': submitForm && $v.account.$each[index].account_id.$error }"
            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
            :placeholder="isShow.account_id"
            v-model="acc.account_id"
          />
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.account.$each[index].account_id.minLength"
          >กรุณากรอก"เลขที่บัญชี"อย่างน้อย {{$v.account.$each[index].account_id.$params.minLength.min}} ตัวเลข</label>
          <label
            class="error invalid-feedback"
            v-if="!$v.account.$each[index].account_id.maxLength"
          >กรุณากรอก"เลขที่บัญชี"ไม่เกิน {{$v.account.$each[index].account_id.$params.maxLength.max}} ตัวเลข</label>
          <label
            v-if="submitForm && !$v.account.$each[index].account_id.required"
            class="invalid-feedback"
          >กรุณากรอกเลขที่บัญชี</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label><span class="text-danger">*</span>{{ (account.length > 1 ? ` ${isShow.account_branch} ${index+1}` : ` ${isShow.account_branch}`)}}</label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': submitForm && $v.account.$each[index].account_branch.$error }"
            :placeholder="isShow.account_branch"
            v-model="acc.account_branch"
          />
          <!-- vuelidate -->
          <label
            v-if="submitForm && !$v.account.$each[index].account_branch.required"
            class="invalid-feedback"
          >กรุณากรอกสาขาธนาคาร</label>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label><span class="text-danger">*</span>{{ (account.length > 1 ? ` ${isShow.branch_code} ${index+1}` : ` ${isShow.branch_code}`)}}</label>
          <input
            type="number"
            class="form-control hide-arrow"
            :class="{ 'is-invalid': submitForm && $v.account.$each[index].branch_code.$error }"
            :placeholder="isShow.branch_code"
            v-model="acc.branch_code"
          />
          <small class="text-muted">*ใช้สำหรับโอนเงิน (กรณีกรอกไม่ถูกต้อง ระบบจะไม่สามารถโอนเงินให้คุณได้)</small>
          <!-- vuelidate -->
          <label
            class="error invalid-feedback"
            v-if="!$v.account.$each[index].branch_code.minLength"
          >กรุณากรอก"รหัสสาขา"อย่างน้อย {{$v.account.$each[index].branch_code.$params.minLength.min}} ตัวเลข</label>
          <label
            class="error invalid-feedback"
            v-if="!$v.account.$each[index].branch_code.maxLength"
          >กรุณากรอก"รหัสสาขา"ไม่เกิน {{$v.account.$each[index].branch_code.$params.maxLength.max}} ตัวเลข</label>
          <label
            v-if="submitForm && !$v.account.$each[index].branch_code.required"
            class="invalid-feedback"
          >กรุณากรอกรหัสสาขา</label>
        </div>
      </div>
    </div>
    <hr class="my-4" />
    <h6 class="heading-small text-muted mb-4">อัพโหลดรูปภาพ</h6>
    <div class="row">
      <template v-for="(image,index) in images" >
        <div class="col-lg-6" :key="index" v-if="!image.disable">
          <div class="form-group">
            <label>
              <span class="text-danger">*</span> {{image.lable}} 
              <small class="text-muted" v-if="image.name == 'image_account' || image.name == 'image_business_account'">(ต้องตรงกับเอกสารจริง)</small>
              <a href="#" @click="exIdentity.show = true" v-if="image.name == 'image_tax_double'">ดูตัวอย่าง</a>
            </label>
              <!-- :state="(submitForm && $v.images.$each[index].file.$error) ? false : null" -->
            <b-form-file 
              :state="validateImages(index)"
              accept=".jpg, .png"
              placeholder="เลือกรูปภาพ"
              @change="uploadImage(index,$event)"
              v-model="image.file"
            ></b-form-file>
            <div class="text-center pt-2" v-if="image.preview">
              <img :src="image.preview" alt="Image" width="150" height="150">
            </div>
            <!-- <label
              v-if="submitForm && !$v.images.$each[index].file.required"
              class="invalid-feedback"
            >กรุณาอัพโหลดรูปภาพ</label> -->
          </div>
        </div>
      </template>
    </div>
    <ModalExampleIdentity :exIdentity="exIdentity" />
  </form>
</template>

<script>
import formatBank from "@/plugins/formatBank.js"
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import ModalExampleIdentity from '@/components/custom/brance/ModalExampleIdentity'
import swapLang from "@/plugins/swapLang.js";
import Compressor from 'compressorjs'

import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
} from "vuelidate/lib/validators";
const API_URL = process.env.VUE_APP_API;
export default {
    name:"FormVerify",
    components:{
      AutocompletesAddress,
      ModalExampleIdentity
    },
    props: {
        submitForm: Boolean,
        data: Object,
        account: Array,
        images: Array,
        typeFormTab: String,
        tabKey: String,
        disabledEmail: Boolean
    },
    data(){
      return{
        chageTypeByUser: false,
        loadingEmail: false,
        userLogin: "",
        ListNameTitle: [],
        bank: formatBank,
        exIdentity: {
          show: false
        }
      }
    },
    validations(){
      return this.rule
    },
    mounted(){
      this.userLogin = JSON.parse(localStorage.getItem("user"));
    },
    methods:{
      onSubmitAddress( ads , objKey ){
        Object.keys(this[objKey]).forEach(key=>{
          if( ads[key] ){
            this[objKey][key] = ads[key]
          }else if( key == 'state' ){
            this[objKey]['state'] = ads['sub-district']
          }
          else{
            this[objKey][key] = this[objKey][key]
          }
        })
      },
      manageNameAccout(){
        this.account.forEach( acc => {
          acc.account_name = this.data.name
        })
      },
      switchTabForCommission(){
        if(this.typeFormTab == 'cod'){
          return false
        }

        this.chageTypeByUser = true

        if( ['1','2','3','7','8','9'].includes( String(this.data.name_title.code)) ){
          this.$emit('update:tabKey', 'person');
        }else{
          this.$emit('update:tabKey', 'company');
        }        
      },
      validateImages( index ){
        let res = null
        if( this.submitForm && this.$v.images.$each && this.$v.images.$each[index].file.$error ){
          res = false
        }else if( this.$v.images[index] && this.$v.images[index].$error ){
          res = false
        }
        else{
          res = null
        }

        // else if( this.$v.images[index] && this.$v.images[index].$error ){
        //   res = false
        // }
        return res
      },
      // :state="(submitForm && $v.images.$each[index].file.$error) ? false : null"
      uploadImage(index,e) {
        if (e.target.files.length < 1) return false;
          const image = e.target.files[0]
          let SELF = this
          new Compressor(image, {
            quality: 0.6,
            maxHeight: 1024,
            maxHeight: 1024,
              success(result) {
                const reader = new FileReader();
                reader.readAsDataURL(result)
                reader.onload = e => {
                  SELF.$set(SELF.images[index], 'preview' , e.target.result)
                }
              }
          })
      },
      default_images(){
        return [
          {
            name:'image_tax_front',
            lable:'รูปภาพบัตรประชาชนด้านหน้า',
            file:null,
            preview:"",
          },
          {
            name:'image_tax_back',
            lable:'รูปภาพบัตรประชาชนด้านหลัง',
            file:null,
            preview:"",
          },
          {
            name:'image_tax_double',
            lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
            file:null,
            preview:"", 
          },
          {
            name:'image_account',
            lable:'รูปภาพสมุดบัญชี',
            file:null,
            preview:"",
          },
        ]
      },
      genEmailShippop(){
        this.loadingEmail = true
        this.$http
          .get(API_URL + "/gen/email", {
            headers: {
                Token: localStorage.getItem("access_token")
            }
          })
          .then(res => {
            if(res){
              this.loadingEmail = false
              this.data.email = res.data.data;
            }
          });
      },
      checkTax(){
        this.data.tax_id = this.swapTaxt(this.data.tax_id)
      },
      swapTaxt(text){
        let swap = text.split('')
        let scanTaxt = ''
        swap.forEach(value =>{
          if(swapLang[value]){
            scanTaxt += swapLang[value]
          }else{
            scanTaxt += value
          }
        });
        return scanTaxt;
      },
      isAdmin(){
        return this.userLogin.role === 'admin'
      },
      isMember(){
        return this.userLogin.role === 'admin'
      },
    },
    computed:{

      isShow() {

        let results = {
          'listNameTitle' : 'nameTitle' ,
          'nameTitle' : 'คำนำหน้า' ,
          'name' : 'ชื่อ-สกุล' ,
          'card_id' : 'เลขบัตรประชาชน' ,
          'laser_code' : 'เลขหลังบัตรประชาชน' ,
          'date_birthday' : 'วันเกิด' ,
          'date_expiry' : 'วันที่บัตรหมดอายุ' ,
          'email' : 'E-mail' ,
          'tel' : 'เบอร์โทรศัพท์' ,
          'address' : 'ที่อยู่ (ตามบัตรประชาชน)' ,
          'state' : 'ตำบล/แขวง' ,
          'district' : 'อำเภอ/เขต' ,
          'province' : 'จังหวัด' ,
          'postcode' : 'รหัสไปรษณีย์' ,
          'account_bank' : 'ธนาคาร' ,
          'account_id' : 'เลขที่บัญชี' ,
          'account_name' : 'ชื่อบัญชีธนาคาร' ,
          'branch_code' : 'รหัสสาขา' ,
          'account_branch' : 'สาขาธนาคาร' ,
          'visible': {
            'laser_code' : true ,
            'date_birthday' : true ,
            'date_expiry' : true
          }
        }
        if( this.typeFormTab == 'cod' ){
          this.data.name_title = ""
        }

        if( this.chageTypeByUser == true ){

          this.data.date_birthday = ""
          this.data.date_expiry = ""

        }

        this.images.forEach(( item , index ) => {

          if( this.images[index].hasOwnProperty("disable") ){

            this.images[index].disable = false

          }

          if( this.chageTypeByUser == true ){

            this.images[index].file = null
            this.images[index].preview = ""

          }
        })

        if( this.tabKey == 'company' ){
          this.ListNameTitle = [
            { code: 4 , nameTitle: 'บจก.' , nameTitleEng: 'MR'},
            { code: 5 , nameTitle: 'บริษัท' , nameTitleEng: 'MR'},
            { code: 6 , nameTitle: 'ห้างหุ้นส่วนจำกัด' , nameTitleEng: 'MR'},
          ],
          results.name = 'ชื่อบริษัท'
          results.card_id = 'เลขประจำตัวผู้เสียภาษี'
          results.visible.laser_code = false
          results.visible.date_expiry = false
          results.visible.date_birthday = false
          results.address = 'ที่อยู่จดทะเบียน (ตามภพ.20 ถ้ามี)'
          // images group
          this.images[0].name = 'image_company_certificate' 
          this.images[0].lable = 'หนังสือรับรองบริษัท (หน้าแรก)' 

          this.images[1].name = 'image_certified_of_vat' 
          this.images[1].lable = 'ภพ.20 (หน้าแรก ถ้ามี)' 

          this.images[2].name = 'image_business_account' 
          this.images[2].lable = 'รูปภาพสมุดบัญชีบริษัท (เป็นชื่อบริษัทเท่านั้น)' 

          this.images[3].disable = true
          this.images[3].name = 'image_company'
          this.images[3].lable = 'รูปบริษัท' 

          this.data.laser_code = '-'
          this.data.date_birthday = '0000-00-00'
          this.data.date_expiry = '0000-00-00'

        }else if( this.tabKey == 'person' ){

          this.ListNameTitle = [
            { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
            { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
            { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
            { code: 7 , nameTitle: 'ว่าที่ ร.ต. หญิง' , nameTitleEng: 'MISS'},
            { code: 8 , nameTitle: 'พลฯหญิง' , nameTitleEng: 'MISS'},
            { code: 9 , nameTitle: 'ว่าที่ ร.ต.' , nameTitleEng: 'MR'},
          ]
          // images group
          this.images[0].name = 'image_tax_front' 
          this.images[0].lable = 'รูปภาพบัตรประชาชนด้านหน้า' 

          this.images[1].name = 'image_tax_back' 
          this.images[1].lable = 'รูปภาพบัตรประชาชนด้านหลัง'

          this.images[2].name = 'image_tax_double' 
          this.images[2].lable = 'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน'

          this.images[3].name = 'image_account' 
          this.images[3].lable = 'รูปภาพสมุดบัญชี'

          // this.data.laser_code = ""

        }else if( this.tabKey == 'passport' ){
          this.ListNameTitle = [
            { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
            { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
            { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
          ]
          results.listNameTitle = 'nameTitleEng' 
          results.visible.laser_code = false
          results.card_id = 'หมายเลขพาสปอร์ต'
          results.address = 'ที่อยู่ (ในประเทศไทย)'

          // images group
          this.images[0].name = 'image_passport_front' 
          this.images[0].lable = 'รูปภาพพาสปอร์ตด้านหน้า' 

          this.images[1].name = 'image_passport_double' 
          this.images[1].lable = 'รูปถ่ายคู่กับพาสปอร์ต' 

          this.images[2].name = 'image_account' 
          this.images[2].lable = 'รูปภาพสมุดบัญชี' 

          this.images[3].disable = true
          this.images[3].name = 'image_passport'
          this.images[3].lable = 'รูปพาสปอร์ต' 

          this.data.laser_code = '-'
        }

        if( this.typeFormTab == 'commission' ){
          if( this.tabKey == 'person' ){
             results.visible.laser_code = false
            this.images[1].disable = true
          }   
          this.ListNameTitle = [
            { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
            { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
            { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
            { code: 7 , nameTitle: 'ว่าที่ ร.ต. หญิง' , nameTitleEng: 'MISS'},
            { code: 8 , nameTitle: 'พลฯหญิง' , nameTitleEng: 'MISS'},
            { code: 9 , nameTitle: 'ว่าที่ ร.ต.' , nameTitleEng: 'MR'},
            { code: 4 , nameTitle: 'บจก.' , nameTitleEng: 'MR'},
            { code: 5 , nameTitle: 'บริษัท' , nameTitleEng: 'MR'},
            { code: 6 , nameTitle: 'ห้างหุ้นส่วนจำกัด' , nameTitleEng: 'MR'},
          ];
        }
        return results
      },
      rule(){
        let res = {
          data:{
            name_title: { required },
            name: { required, minLength: minLength(3) },
            address: { required, minLength: minLength(5) },
            state: { required },
            district: { required },
            province: { required },
            postcode: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) },
            tel: { required, numeric, minLength: minLength(9) },
            tax_id: { required, minLength: minLength(13), maxLength: maxLength(13) },
            email: { required, email },
            laser_code: { required },
            date_birthday: { required },
            date_expiry: { required },
          },
          account:  {
            $each: {
              account_id: {
                required, 
                minLength: minLength(10), 
                maxLength: maxLength(15)
              },
              account_name: { 
                required, 
                minLength: minLength(3) 
              },
              account_branch: {
                required,
              },
              account_bank: {
                required,
              },
              branch_code: {
                required,
                minLength: minLength(3), 
                maxLength: maxLength(4)
              }
            }
          },
          images: {
            $each: {
              file: { required }
            }
          }
        }

        if( this.tabKey == 'company' ){
          
          res.data.date_birthday = {}
          res.data.laser_code = {}
          res.data.date_expiry = {}
          res.images = {}
          res.images[0] = { file:{required} }
          res.images[2] = { file:{required} }

        }

        if( this.tabKey == 'passport' ){

          res.data.laser_code = {}
          res.data.tax_id = { required, minLength: minLength(7), maxLength: maxLength(30) },
          res.images = {}
          res.images[0] = { file:{required} }
          res.images[1] = { file:{required} }
          res.images[2] = { file:{required} }
        }

        if( this.typeFormTab == 'commission' && this.tabKey == 'person' ){
          res.data.laser_code = {}
          res.images = {}
          res.images[0] = { file:{required} }
          res.images[2] = { file:{required} }
          res.images[3] = { file:{required} }
        }

        return res
      },
  }
}
</script>

<style scoped >
input[type="text"]:disabled {
  background: #dddddd;
}
  .loader-autocomplete {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 100%;
      width: 19px;
      height: 20px;
      animation: spin 1s linear infinite;
  }
  .loading-box {
    position: absolute;
    top: 50%;
    right: 85px;
    transform: translate(-50%, -50%);
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

</style>